// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"49d3304c","312":"237d1c21","385":"fdc473f2","834":"66b2c2bd","909":"65a1a500"}[chunkId] + ".chunk.js";
};